<div class="generalPage" role="main" aria-label="Home Page" *ngIf="outcome">
  <div [class.welcome-container-newUser]="newUser" role="region" aria-label="Heading-container" [class.welcome-container]="!newUser">
    <h1 class="welcome-user-name-padding top-heading content-blue singleLine mtb-0-2" role="heading" aria-level="2">{{header}}</h1>
    <div class="new-update-container" *ngIf="accessType == 'Professional' && !maintenanceFlag">
      <div *ngIf="home_launchmessage.changingThisBreaksApplicationSecurity.length != 0" [innerHTML]="home_launchmessage">
      </div>
    </div>
    <div class="maintenance-message-container mt-4" *ngIf="maintenanceFlag">
      <div *ngIf="maintenanceMessage.length != 0" [innerHTML]="maintenanceMessage">
      </div>
    </div>
    <div class="padding-container" [class]="basicView && maintenanceFlag ? 'mt-0 pt-12px' : ''" *ngIf="newUser">
      <div *ngIf="home_NewLaunch !=''" class="mb-1" (click)="openLinkById($event,true)" (keyup.enter)="openLinkById($event,true)" [innerHTML]="home_NewLaunch">
      </div>
      <div class="flex-display">
        <div class="app-intro-help">
          <div class="question font-18 content-blue" tabindex="0">
            {{whatIsCod}}
          </div>
          <div class="answer font-16 content-blue width-80" tabindex="0">
            {{whatIsCodDesc}}
          </div>
        </div>
        <div class="app-intro-help">
          <div class="question font-18 content-blue" tabindex="0">
            {{howToUse}}
          </div>
          <div class="answer font-16 content-blue width-80">
            <span tabindex="0">{{howToUseDescArr1}}</span>
            <span id="/help" (click)="openLinkById($event)" class="highlight-blue border-bottom-help cursor-pointer singleLine" tabindex="0">{{helpTopicText}}</span>
            <span tabindex="0">{{howToUseDescArr2}}</span>
            <span id={{basicViewUserPdfName}} class="highlight-blue border-bottom-help cursor-pointer singleLine" (click)="openLinkById($event,true)" tabindex="0">{{proViewUserGuide}}</span>
            <span tabindex="0">{{howToUseDescArr3}}</span>
          </div>

          <div class="help-topic-container h-20px highlight-blue  flex-display cursor-pointer" (click)="openLinkById($event,true)" (keyup.enter)="openLinkById($event,true)">
            <div class="border-bottom-help" id={{howToUseCodFileName}} tabindex="0">{{howToUseCod}}</div> <div class="ml-6px"><img id={{howToUseCodFileName}} src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="History"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!basicView" class="content-blue highlight-blue">
      <div class="welcome-title-text georgiaRegularFont aboutCodificationHeader-container content-blue" tabindex="0">{{aboutCodificationHeader}}</div>
      <div class="about-codification-content-container mt-1rem" (contextmenu)="onRightClick($event,'SitesPdf')" (click)="openLinkById($event,true)" (keyup.enter)="openLinkById($event,true)" [innerHTML]="description" tabindex="0"></div>
    </div>
  </div>
  <div class="history-container flex-display" *ngIf="!basicView && accessType != 'Academic'">
    <div class="history-box">
      <div class="history-heading flex-display">
        <div>
          <img src="../../../assets/icons/clock-circle-black.svg" class="watch-image image-info" alt="History">
        </div>
        <div class="content-blue" tabindex="0">
          <h2 class="history-title-text mtb-0-2">{{history}}</h2>
        </div>
      </div>
      <div class="mt_1 content-blue highlight-blue width-80" tabindex="0">
        {{historyDesc}}
      </div>
      <div *ngIf="!newUser">
        <div *ngFor="let history of myHistory" class="history-content pl-18px">
          <div class="font-14 recentDate">{{history.recentDate | date:'longDate'}}</div>
          <div class="flex-display history-breadcrumb" *ngIf="history.historyType != 'Bookmark' && history.historyType != 'Annotation'">
            <div *ngFor="let breadcrumbParts of history.breadCrumb.toString().split('~')">
              <div class="flex-display font-14">
                {{breadcrumbParts}}
                <span *ngIf="breadcrumbParts != history.breadCrumb.toString().split('~')[history.breadCrumb.toString().split('~').length-1]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right"></span>
                <span *ngIf="breadcrumbParts == history.breadCrumb.toString().split('~')[history.breadCrumb.toString().split('~').length-1]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right"></span>
              </div>
            </div>
          </div>
          <div class="flex-display" [class.mt-8px]="history.historyType == 'Bookmark' || history.historyType == 'Annotation'" [class.mt-4px]="history.historyType != 'Bookmark' && history.historyType != 'Annotation'">
            <div *ngIf="history.historyType== 'Bookmark'" tabindex="0">
              <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="Bookmark">&nbsp;&nbsp;
            </div>
            <div *ngIf="history.historyType== 'Annotation'" tabindex="0">
              <img src="../../../assets/icons/pencil-alt.svg" class="history-type-images" alt="Annotation">&nbsp;&nbsp;
            </div>
            <div *ngIf="history.historyType== 'Annotation' || history.historyType== 'Bookmark'">
              <a class="font-18 highlight-blue cursor-pointer" (contextmenu)="onRightClick($event,history)" (click)="redirectToHistoryUrl(history,$event)" (keyup.enter)="redirectToHistoryUrl(history,$event)" tabindex="0">
                {{history.historyTitle}}
              </a>
            </div>
            <div *ngIf="history.historyType== 'VisitedPages'">
              <a class="font-18 highlight-blue cursor-pointer" (contextmenu)="onRightClick($event,history)" (click)="redirectToHistoryUrl(history,$event)" (keyup.enter)="redirectToHistoryUrl(history,$event)" tabindex="0">
                {{history.navigationPath}}
              </a>
            </div>
          </div>
        </div>
        <div class="mt-40px h-20px highlight-blue flex-display">
          <a class="pdf-link" [routerLink]="['/MyHistory']" (keyup.enter)="ViewCompleteHistory()" tabindex="0">{{completeHistory}}</a><div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="History"></div>
        </div>
      </div>
    </div>
    <div class="history-box" *ngIf="accessType == 'Professional'">
      <div class="history-heading flex-display">
        <img src="../../../assets/icons/bookmark-home.svg" class="history-image image-info" alt="Bookmark">
        <div class="content-blue" tabindex="0">
          <h2 class="history-title-text mtb-0-2">{{bookmark}}</h2>
        </div>
      </div>
      <div class="mt_1 content-blue highlight-blue width-80" tabindex="0">
        {{bookmarkDesc}}
      </div>
      <div *ngIf="!newUser">
        <div *ngFor="let bookmark of topBookmark" class="history-content pl-18px">
          <div class="font-14 recentDate">{{bookmark.recentDate | date:'longDate'}}</div>
          <div class="flex-display history-breadcrumb mt-4px">
            <div *ngFor="let breadcrumbParts of bookmark.breadCrumb.toString().split('~')">
              <div *ngIf="breadcrumbParts != bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length]" class="flex-display font-14">
                {{breadcrumbParts}}
                <span *ngIf="breadcrumbParts != bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length-1]"><img src="../../../assets/icons/Arrow Right (Alt).svg" class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"></span>
                <span *ngIf="breadcrumbParts == bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length-1]"><img src="../../../assets/icons/Arrow RightDown (Alt).svg" class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"></span>
              </div>
            </div>
          </div>
          <div class="flex-display mt-8px">
            <div>
              <a class="font-18 highlight-blue cursor-pointer" (contextmenu)="onRightClick($event,bookmark)" (click)="redirectToBookmarkUrl(bookmark,$event)" (keyup.enter)="redirectToBookmarkUrl(bookmark,$event)" tabindex="0">
                {{bookmark.historyTitle}}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="viewAllHistory" *ngIf="!newUser">
        <div class="help-topic-container highlight-blue h-20px flex-display cursor-pointer">
          <a class="pdf-link" [routerLink]="['/myBookmarks']" (keyup.enter)="ViewAllBookmark()" tabindex="0">{{viewAllBookmark}}</a> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="History"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="new-update-container flex-display">
    <div class="history-box">
      <div class="history-heading">
        <div class="content-blue" tabindex="0">
          <h2 class="history-title-text mtb-0-2">{{whatsNew}}</h2>
        </div>
      </div>
      <div class="mt_1 content-blue highlight-blue width-80" tabindex="0">
        {{whatsNewDesc}}
      </div>
      <div>
        <div *ngFor="let whatsnew of whatsNewObject" class="history-content pl-18px">
          <div class="mb-24px">
            <div class="font-14 recentDate mb-9px" [innerHTML]="whatsnew.pdfTitle"></div>
            <div class="font-18 flex-display width-80">
              <img src="../../../assets/icons/PDF_icon.svg" class="whatsNew-image image-info" alt="PDF">
              <div>
                <a class="highlight-blue cursor-pointer" (contextmenu)="onRightClick($event,'SitesPdf')" [id]="whatsnew.pdfLink" (click)="openLinkById($event,true)" tabindex="0" (keyup.enter)="openLinkById($event)" [innerHTML]="whatsnew.fileName"></a>&nbsp;
                <img src="../../../assets/icons/new-window-blue.svg" class="whatsNew-image image-info" alt="Open PDF Attached">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="viewAllHistory">
        <div class="help-topic-container h-20px  flex-display" tabindex="0">
          <div (click)="OpenLink($event)" (contextmenu)="onRightClick($event)" [innerHTML]="pastUpdateLink"></div> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="ml-6px arrow-right-image" alt="Whats new"></div>
        </div>
      </div>


      <div class="viewAllHistory">
        <div class="help-topic-container h-20px flex-display" tabindex="0">
          <div [innerHTML]="recentDocLink" (contextmenu)="onRightClick($event)" (click)="OpenLink($event)"></div> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="ml-6px arrow-right-image" alt="Whats new"></div>
        </div>
      </div>

    </div>
    <div class="history-box">
      <div class="history-heading flex-display">
        <div class="history-title-text content-blue" tabindex="0">
          <h2 class="history-title-text mtb-0-2">{{helpTitle}}</h2>
        </div>
      </div>
      <div class="mt_1 content-blue highlight-blue width-80" tabindex="0">
        {{helpDescription}}
      </div>
      <div class="help-topic-container h-20px flex-display">
        <a class="pdf-link" [routerLink]="['/help']" tabindex="0" (keyup.enter)="NavigateToHelp()">{{helpTopics.linkText}}</a> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="Help Topics"></div>
      </div>
      <div class="help-topic-container h-20px flex-display" *ngIf="basicView">
        <div (click)="openLinkById($event,true)" (contextmenu)="onRightClick($event,'DocsPdf')" (keyup.enter)="openLinkById($event)" tabindex="0">
          <a class="pdf-link" id={{basicUserGuide.pdffile.title}}>{{basicUserGuide.linkText}}</a>
        </div>
        <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="BasicUserGuide"></div>
      </div>
      <div class="help-topic-container h-20px flex-display" *ngIf="!basicView">
        <div (click)="openLinkById($event,true)" (contextmenu)="onRightClick($event,'DocsPdf')" (keyup.enter)="openLinkById($event)" tabindex="0">
          <a class="pdf-link" id={{proUserGuide.pdffile.title}}>{{proUserGuide.linkText}}</a>
        </div>
        <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="ProUserGuide"></div>
      </div>
      <div class="help-topic-container h-20px  flex-display">
        <div (click)="openLinkById($event,true)" (contextmenu)="onRightClick($event,'DocsPdf')" (keyup.enter)="openLinkById($event)" tabindex="0">
          <a class="pdf-link" id={{aboutCod.pdffile.title}}>{{aboutCod.linkText}}</a>
        </div>
        <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="About COd"></div>
      </div>

      <div class="help-topic-container h-20px  flex-display" (click)="addGeneralFeedback()" (keyup.enter)="addGeneralFeedback()" tabindex="0">
        <div class="pdf-link">{{generalFeedback.linkTitle}}</div> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="General Feedback"></div>
      </div>

      <div *ngIf="accessType == 'Professional'">
        <div class="help-topic-container h-20px  flex-display" tabindex="0">
          <a class="cursor-pointer" (click)="ResetPassword()" (keyup.enter)="ResetPassword()">{{resetPassword}}</a><div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image ml-6px" alt="licensee"></div>
        </div>
      </div>

    </div>

  </div>
</div>
